import app from './modules/app';
import user from './modules/user';
import activity from './modules/activity';
import permission from './modules/permission';
import camp from './modules/camp';
import getters from './getters';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    activity,
    camp,
    permission,
  },
  getters,
});

export default store;
